import { Button } from "@/components/ui/button";
import {
  CopyLinkButton,
  ShareAccess,
  ShareList,
} from "@/components/ui/sharing";
import { VisibilityScope } from "@/graphql";
import { ResourcePermissionUser } from "@/types/permissions";

import { convertToShareItems } from "./permissionTransformers";

interface SimplifiedShareViewProps {
  visibilityScope: VisibilityScope;
  owner?: ResourcePermissionUser;
  onClose: () => void;
  workspaceInfoMessage?: string;
}

/**
 * Simplified share view for global resources and read-only users
 * Shows only the owner (if applicable), ShareAccess in read-only mode,
 * Copy Link button, and Done button
 */
export function SimplifiedShareView({
  visibilityScope,
  owner,
  onClose,
  workspaceInfoMessage,
}: SimplifiedShareViewProps) {
  const isGlobal = visibilityScope === VisibilityScope.Global;

  // Convert owner to share item format if present and not global
  const ownerItems =
    !isGlobal && owner ? convertToShareItems([owner], [], []) : [];

  return (
    <>
      {/* Show owner for non-global resources */}
      {ownerItems.length > 0 && (
        <ShareList
          items={ownerItems}
          loading={false}
          title="Owner"
          className="mb-4"
        />
      )}

      {/* Share access in read-only mode */}
      <ShareAccess
        visibilityScope={visibilityScope as "User" | "Workspace" | "Global"}
        canShareToWorkspace={false}
        infoMessage={!isGlobal ? workspaceInfoMessage : undefined}
      />

      {/* Action buttons */}
      <div className="flex justify-between mt-8 items-center gap-1">
        <CopyLinkButton />
        <Button onClick={onClose} intent="primary" className="px-12">
          Done
        </Button>
      </div>
    </>
  );
}
